import { useModalsStore } from '@/shared/stores/modals.js'

export const useModals = () => {
  const { closeModal, openModal } = useModalsStore()

  return {
    openModal,
    closeModal,
  }
}
